import variables from '../../variables';

const {
	sm,	md,	lg,	xl
} = variables.breakpoints;

export default [
	{
		target: '.js-home-accelerators-carousel',
		apiOptions: {

			pagination: {
				el: '.js-home-accelerators-carousel-pagination',
				type: 'bullets',
				clickable: true,
				dynamicBullets: true
			},
			breakpoints: {
				0: {
					spaceBetween: 15,
					slidesPerView: 'auto'
				},
				[sm]: {
					slidesPerView: 2,
					spaceBetween: 15
				},
				[lg]: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				[xl]: {
					slidesPerView: 4,
					spaceBetween: 30
				}
			}
		}
	},
	{
		target: '.js-home-interaction-carousel',
		apiOptions: {
			slidesPerView: 'auto',
			spaceBetween: null,

			loop: true,
			pagination: {
				el: '.js-home-interaction-carousel-pagination',
				type: 'bullets',
				clickable: true,
				dynamicBullets: true
			},
		}
	}
]
